<template>
    <div
        class="tooltip-wrapper"
        @mouseenter="visible = true"
        @mouseleave="visible = false"
    >
        <!-- Trigger -->
        <slot />

        <!-- Tooltip -->
        <transition name="tooltip-fade">
            <div
                v-if="visible"
                class="custom-tooltip"
                :class="[`tooltip-${position}`, tooltipClass]"
            >
                <slot name="content" />

                <span
                    class="tooltip-arrow"
                    :class="arrowClass"
                ></span>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Tooltip',

    props: {
        position: {
            type: String,
            default: 'top',
            validator(value) {
                return ['top', 'bottom', 'left', 'right'].includes(value)
            }
        },

        tooltipClass: {
            type: [String, Array, Object],
            default: ''
        }
    },

    data() {
        return {
            visible: false
        }
    },

    computed: {
        arrowClass() {
            return this.tooltipClass
        }
    }
}
</script>

<style scoped>
.tooltip-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
}

/* Tooltip box */
.custom-tooltip {
    position: absolute;
    z-index: 9999;

    min-width: 180px;
    max-width: 300px;

    padding: 8px 12px;

    background: #333;
    color: #fff;

    border-radius: 6px;

    font-size: 12px;
    line-height: 1.5;

    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Positions */
.tooltip-top {
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
}

.tooltip-bottom {
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
}

.tooltip-left {
    right: calc(100% + 10px);
    top: 50%;
    transform: translateY(-50%);
}

.tooltip-right {
    left: calc(100% + 10px);
    top: 50%;
    transform: translateY(-50%);
}

/* Arrow */
.tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
}

.tooltip-top .tooltip-arrow {
    top: 100%;
    left: 50%;
    transform: translateX(-50%);

    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #333;
}

.tooltip-bottom .tooltip-arrow {
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);

    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #333;
}

.tooltip-left .tooltip-arrow {
    left: 100%;
    top: 50%;
    transform: translateY(-50%);

    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #333;
}

.tooltip-right .tooltip-arrow {
    right: 100%;
    top: 50%;
    transform: translateY(-50%);

    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #333;
}

/* Animation */
.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.tooltip-fade-enter,
.tooltip-fade-leave-to {
    opacity: 0;
}
</style>